import { Carrier, CarrierDirectory } from '../models/client/carrier'
import { apiRequest } from './apiRequest'

const getCarriers = async ({
    token,
    search,
}: {
    token: string
    search?: string
}): Promise<CarrierDirectory> => {
    let filter
    if (search) {
        filter = {
            name: {
                $ilike: `${search}%`,
            },
        }
    }
    try {
        const { data: nextData } = await apiRequest<Carrier[]>({
            path: '/carriers/search',
            method: 'POST',
            token,
            parameters: {
                sort: 'name ASC',
            },
            data: {
                filter,
            },
        })
        const directory: CarrierDirectory = {}

        return nextData.reduce((draft: any, nextCarrier: any) => {
            if (!nextCarrier.id) return draft
            draft[nextCarrier.id] = nextCarrier
            return draft
        }, directory)
    } catch (e) {
        return {}
    }
}

const getCarrierById = async ({
    token,
    carrierId,
}: {
    token: string
    carrierId: string
}): Promise<Carrier> => {
    const { data } = await apiRequest<Carrier>({
        path: `/carriers/${carrierId}`,
        method: 'GET',
        token,
    })
    return data
}

export const carrierClient = {
    getCarriers,
    getCarrierById,
}
